import { render, staticRenderFns } from "./officialNumberDetails.vue?vue&type=template&id=41f8a461&scoped=true&"
import script from "./officialNumberDetails.vue?vue&type=script&lang=js&"
export * from "./officialNumberDetails.vue?vue&type=script&lang=js&"
import style0 from "./officialNumberDetails.vue?vue&type=style&index=0&id=41f8a461&prod&scoped=true&lang=css&"
import style1 from "./officialNumberDetails.vue?vue&type=style&index=1&id=41f8a461&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f8a461",
  null
  
)

export default component.exports